import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useNavigation } from './context/NavigationContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { hasNavigatedFromRoot } = useNavigation();
  const location = useLocation();

  if (!hasNavigatedFromRoot) {
    // Redirigir a la página principal si no ha navegado desde la ruta raíz
    return <Navigate to="/" state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
